import styled, { css } from 'styled-components';
import { layout } from 'styled-system';

import { Select, TextInput, PlacesAutocompleteInput } from 'components/core';

export const baseInputStyles = css`
  /* Locally-scoped vars per the escape-hatch convention in concierge-variables.ts. */
  --fi-bg: ${({ theme }) => theme.colors.primaryGrey};
  --fi-border: ${({ theme }) => theme.colors.grey[80]};
  --fi-text: ${({ theme }) => theme.colors.grey[30]};
  --fi-focus-bg: ${({ theme }) => theme.colors.white};
  --fi-focus-border: ${({ theme }) => theme.colors.blue[55]};
  --fi-focus-shadow: ${({ theme }) => theme.colors.blueShadow};

  .concierge-mode & {
    --fi-bg: var(--dcm-color-surface-muted);
    --fi-border: var(--dcm-color-border);
    --fi-text: var(--dcm-color-text-primary);
    --fi-focus-bg: var(--dcm-color-surface);
    --fi-focus-border: var(--dcm-color-focus);
    --fi-focus-shadow: var(--dcm-color-focus-shadow);
  }

  background: var(--fi-bg);
  border: 1px solid var(--fi-border) !important;
  color: var(--fi-text) !important;
  border-radius: ${({ theme }) => theme.customized.radius.sm} !important;
  height: 55px;

  & > input {
    ${({ label, $addLabelOffset }) => ($addLabelOffset && label ? `padding-top: 30px` : '')};
    padding-left: 25px;
    font-size: 16px;
    font-weight: bold;
    &.MuiInputBase-input {
      color: ${({ value }) => value && 'var(--fi-text)'} !important;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.75;
    }
  }

  &.Mui-focused {
    background-color: var(--fi-focus-bg);
    border-color: var(--fi-focus-border) !important;
    box-shadow: 0px 1px 5px var(--fi-focus-shadow);
  }

  &.empty:not(.Mui-focused) {
    color: transparent !important;
  }

  &.Mui-error {
    border: 1px solid ${({ theme }) => theme.colors.red[60]} !important;
    &.MuiFormLabel-root {
      color: ${({ theme }) => `${theme.colors.red[60]} !important`};
    }
  }

  input:-webkit-autofill {
    border-color: ${({ theme }) => theme.colors.blue[55]} !important;
    padding-top: 23px;
    padding-bottom: 11px;
  }
`;

export const StyledTextInput = styled(TextInput)`
  ${baseInputStyles}

  & > input {
    font-weight: 700;
    padding-top: 23px;
  }

  ${layout}

  ${({ hideFieldset }) =>
    hideFieldset &&
    css`
      & > fieldset {
        display: none;
      }
    `}
`;

export const StyledPlacesAutocompleteInput = styled(PlacesAutocompleteInput)`
  ${baseInputStyles}

  & > input {
    padding-top: 36px;
  }
`;

export const StyledSelect = styled(Select)`
  ${baseInputStyles};

  & .MuiSelect-select {
    justify-content: flex-start;
    padding-left: 25px;
  }

  ${layout}
`;
